import { useQuery } from '@tanstack/react-query';
import { Entity, mapEntity } from '@toggle/toggle';
import React from 'react';

import { PriceDisplayView } from '~/components/price-display-view/PriceDisplayView';
import { mapEntityToPriceEntity, useLivePrice } from '~/hooks/use-live-price';
import { useSnakeMeta } from '~/hooks/use-snake/useSnake';
import { getPreliminaryPrice } from '~/services/price/price-service';
import { useLegendPriceHover } from '~/views/turbo-chart/hooks/use-legend-price-hover/useLegendPriceHover';
import { getPriceData } from '~/widgets/asset-overview-widget/utils/asset-box/asset-box-helpers';

import * as S from '../insights-left-section/InsightsLeftSection.styles';

interface EntityLivePriceProps {
  entity: Entity;
}

export const EntityLivePrice = ({ entity }: EntityLivePriceProps) => {
  const priceHover = useLegendPriceHover({
    elementRef: {
      current: document,
    },
    enabled: false,
  });

  const mappedEntity = mapEntity(entity);

  const { data: snakeMeta } = useSnakeMeta(entity?.default_snake);

  const { data: preliminaryPrice } = useQuery({
    queryKey: [entity.subscribable_ticker],
    queryFn: () => getPreliminaryPrice(entity.subscribable_ticker as string),
  });

  const hoverData = priceHover?.panes[0].data[0];
  const priceEntities = mapEntityToPriceEntity(entity, snakeMeta);
  const livePriceData = useLivePrice(priceEntities);
  const livePriceInfo = getPriceData({
    hoverData,
    livePriceData,
    entity: mappedEntity,
    ts: [],
    priceEntity: priceEntities[0],
  });

  return (
    <>
      {preliminaryPrice && (
        <S.Wrapper>
          <PriceDisplayView
            entity={mappedEntity}
            livePriceInfo={livePriceInfo}
            preliminaryPrice={preliminaryPrice.data}
            snakeMeta={snakeMeta}
            isCondensed={false}
            isChartHovered={!!hoverData?.currentPrice}
          />
        </S.Wrapper>
      )}
    </>
  );
};
